<template>
  <div id="article-comments">
    <!-- 文章评论 -->
    <!-- 按钮组 -->
    <el-button-group>
       <el-tooltip
        effect="dark"
        content="勾选列表将选中的评论通过审核"
        placement="top-start"
      >
      <el-button
        type="primary"
        size="large"
        @click="checkComments($event)"
      >
        <el-icon> <Check /> </el-icon>批量审核
      </el-button>
      </el-tooltip>

        <el-tooltip
          effect="dark"
          content="勾选列表将选中的评论进行回复留言"
          placement="top-start"
        >
      <el-button
        type="primary"
        size="large"
        @click="replyArticleComments($event)"
      >
        <el-icon> <Edit /> </el-icon>回复留言
      </el-button>
      </el-tooltip>


      <el-button type="danger" size="large" plain @click="deleteComments($event)"  v-if="isDelect">
        <el-icon> <Delete /> </el-icon>批量删除
      </el-button>
    </el-button-group>
    <RefreshExportHide
      componentTableId="ArticleComments"
      excelName="文章评论"
      @update-list="getList"
    ></RefreshExportHide>
    <!-- 表格组件 -->
    <TableList
      componentTableId="ArticleComments"
      @update-list="updateList"
      excelName="文章评论"
      :table-data="tableData"
      :header-data="headerData"
      :table-height="tableMaxHeight"
      :loading="loading"
      :loading-text="loadingText"
      :empty-text="emptyText"
      @handleEdit="editFnc"
      @searchFnc="searchFnc"
      @openContent="openContent"
      @handleSelection="handleSelection"
    >
      <template #replyCountsCustom="scope">
        <span
          class="hand blue"
          v-if="scope.scope.replyCounts && scope.scope.replyCounts > 0"
          @click="openReply(scope.scope)"
        >
          {{ scope.scope.replyCounts }}条</span
        >
        <span v-else class="gray">未回复</span>
      </template>
      <template #isPassCustom="scope">
        <el-tag type="success" effect="dark" v-if="scope.scope.isPass">
          审核通过
        </el-tag>
        <span class="gray" v-else>未审核</span>
      </template>
    </TableList>
    <!-- 评论内容弹窗 -->
    <div class="content-d">
      <el-dialog
        v-model="contentVisible"
        title="查看评论详情"
        width="800px"
        align-center
        class="contentDialog"
         draggable
              destroy-on-close
      >
        <div v-html="contentDetails" v-if="contentVisible"></div>
      </el-dialog>
    </div>
    <!-- 编辑文章评论 -->
    <el-dialog
      v-model="editVisible"
      title="编辑评论"
      width="580px"
      align-center
      class="content-edit edit-form"
      draggable
      destroy-on-close
    >
      <el-form
        label-width="100px"
        :model="formComments"
        :rules="rules"
        ref="ruleFormRef"
      >
        <el-form-item label="评论时间" prop="createTime">
          <el-date-picker
            v-model="formComments.createTime"
            type="datetime"
            placeholder="请选择评论时间"
            format="YYYY-MM-DD hh:mm:ss"
            value-format="YYYY-MM-DD hh:mm:ss"
          />
        </el-form-item>
        <!-- <el-form-item label="评论IP地址" prop="ip">
          <el-input v-model="formComments.ip" placeholder="请输入评论IP地址" />
        </el-form-item> -->
        <el-form-item label="评论内容" prop="content">
          <el-input
            v-model="formComments.content"
            type="textarea"
            :rows="4"
            placeholder="请输入评论内容"
          />
        </el-form-item>
      </el-form>
      <div class="from_btn">
        <el-button @click="resetForm" size="large">取消</el-button>
        <el-button type="primary" v-if="!editDisabled" size="large" @click="submitForm(ruleFormRef)"
          :disabled = "editDisabled">提交保存</el-button
        >
        <el-button type="primary" size="large" loading v-else>提交中</el-button>
      </div>
    </el-dialog>
    <!-- 回复评论 -->
    <el-dialog
      v-model="replyVisible"
      title="回复评论"
      width="580px"
      align-center
      class="content-edit"
       draggable
              destroy-on-close
    >
      <el-form
        label-width="100px"
        :model="replyComments"
        :rules="rulesReply"
        ref="replyFormRef"
      >
        <el-form-item label="评论时间" prop="createTime">
          <el-date-picker
            v-model="formComments.createTime"
            type="datetime"
            placeholder="请选择评论时间"
            format="YYYY-MM-DD hh:mm:ss"
            value-format="YYYY-MM-DD hh:mm:ss"
            disabled
          />
        </el-form-item>
        <el-form-item label="评论内容" prop="content">
          <el-input
            v-model="formComments.content"
            type="textarea"
            :rows="3"
            placeholder="请输入评论内容"
            disabled
          />
        </el-form-item>
        <el-form-item label="回复内容" prop="replyContent">
          <el-input
            v-model="replyComments.replyContent"
            type="textarea"
            :rows="3"
            placeholder="请输入回复内容"
          />
        </el-form-item>
      </el-form>
      <div class="from_btn">
        <el-button @click="resetReplyForm" size="large">取消</el-button>
        <el-button
          type="primary"
          size="large"
          v-if="!submitDisabled"
          @click="submitReplyForm(replyFormRef)"
          :disabled = "submitDisabled">提交保存</el-button
        >
        <el-button type="primary" size="large" loading v-else>提交中</el-button>
      </div>
    </el-dialog>
    <!-- 评论回复列表 -->
    <el-dialog
      v-model="replyListVisible"
      title="评论回复列表"
      width="580px"
      align-center
      class="content-l"
       draggable
              destroy-on-close
    >
      <el-table
        :data="replyListData"
        border
        style="width: 100%"
        stripe
        :header-cell-style="{ background: '#f5f7fa' }"
        height="300"
      >
        <el-table-column
          prop="replyContent"
          label="回复内容"
          width="220"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <span
              class="hand blue"
              v-if="scope.row.replyContent"
              @click="openReplyContent(scope.row)"
              >{{ scope.row.replyContent }}</span
            >
            <span v-else class="gray">无</span>
          </template>
        </el-table-column>
          align="center"
        <el-table-column prop="createTime" align="center" label="回复时间" width="220" />
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <el-button type="danger" @click="handleDelete(scope.row, $event)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 回复内容弹窗 -->
    <el-dialog
      v-model="contentReplyVisible"
      title="查看回复详情"
      width="500px"
      align-center
      class="content-d"
       draggable
              destroy-on-close
    >
      <div v-html="contentReplyDetails" v-if="contentReplyVisible"></div>
    </el-dialog>
     <!-- 批量操作结果响应 -->
      <el-dialog
        :close-on-click-modal="false"
        v-model="resultVisible"
        :title="resultTitle"
        width="900px"
        append-to-body="false"
        draggable
        destroy-on-close
      >
        <ResultList :resultList="resultList"></ResultList>
      </el-dialog>
    <!-- 底部工具 -->
    <Pagination
      :pagination="pagination"
      :is-loading="loading"
      @change-pagination="changePagination"
    >
    </Pagination>
  </div>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import ResultList from "@/components/ResultList.vue"
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs, onMounted, h,computed } from "vue";

import {
  GetPageList,
  EditComments,
  PassComments,
  ReplyComments,
  GetReplyList,
  DeleteReply,
  Deletes,
} from "../../network/articleComments.js";
import { isNull, lostFocus } from "../../common/utils.js";
import store from "../../store/index";
export default {
  name: "ArticleComments",
  components: {
    TableList,
    Pagination,
    ResultList
  },
  props: {
    tableMaxHeight: Number,
  },
  // 定义属性
  setup() {
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      tableData: [], //表格数据
      resultVisible: false,
      resultTitle: '提示',
      resultList:[],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        }, {
          label: "学员姓名",
          prop: "name",
          width: "150",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "评论内容",
          prop: "content",
          minWidth: "300",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
          isToMoreContents: true,
          showSelf: true, //展示自己的内容，不格式化查看详情
        },
        {
          label: "回复内容",
          prop: "replyCounts",
          width: "150",
          align: "center",
          noSetText: "未设置",
          custom: true,
        },
        {
          label: "审核状态",
          prop: "isPass",
          width: "160",
          align: "center",
          noSetText: "未设置",
          custom: true,
        },
        {
          label: "评论时间",
          prop: "createTime",
          width: "180",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "所属文章",
          prop: "title",
          width: "300",
          align: "center",
          noSetText: "未设置",
          type: "InputSearch",
        },
        {
          label: "IP地址",
          prop: "ip",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "InputSearch",
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: false,
        },
      ],
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      contentVisible: false, //评论内容弹窗
      contentDetails: "", //评论内容详情
      editVisible: false, //编辑文章评论弹窗
      replyVisible: false, //回复评论弹窗
      replyListVisible: false, //评论回复列表弹窗
      replyListData: [], //回复列表数据
      contentReplyVisible: false, //回复内容弹窗
      contentReplyDetails: "", //回复内容详情
      contentReplyId: "", //当前评论内容Id，关联回复内容
      multipleSelection: [], //列表选中

      search: {
        //列表搜索条件
        Title: null,
        Content: null,
        Ip: null,
        pageIndex: 1,
        pageSize: 20,
      },
      formComments: {
        //编辑文章评论
        id: null,
        createTime: null,
        // ip: null,
        content: null,
      },
      replyComments: {
        //回复评论
        id: null,
        replyContent: null,
      },
      rules: {
        createTime: [
          { required: true, message: "请选择评论时间", trigger: "blur" },
        ],
        // ip: [{ required: true, message: "请输入评论IP地址", trigger: "blur" }],
        content: [
          { required: true, message: "请输入评论内容", trigger: "blur" },
        ],
      },
      rulesReply: {
        replyContent: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
      },
      submitDisabled:false,//回复
      editDisabled:false,//编辑
    });
    //挂载后调用函数获取数据
    onMounted(() => {
      getList(); //请求列表数据
    });
    // 获取列表数据
    const getList = async () => {
      data.loading = true;
      const res = await GetPageList(data.search);
      data.loading = false;
      if (res && res.code == 1) {
        data.pagination.total = res.result.totalCount;
        data.tableData = res.result.rows;
      } else {
        ElMessageBox.alert(res.message, "提示", {
          confirmButtonText: "确认",
        });
      }
    };
    // 列表搜索
    const searchFnc = (val) => {
      //搜索文章名称
      if (!isNull(val.prop) && val.prop == "title") {
        data.search.Title = val.value;
      }
      //搜索评论内容
      if (!isNull(val.prop) && val.prop == "content") {
        data.search.Content = val.value;
      }
      //搜索IP地址
      // if (!isNull(val.prop) && val.prop == "ip") {
      //   data.search.Ip = val.value;
      // }
      data.pagination.currentPage = 1;
      getList();
    };
    //更新列表
    const updateList = () => {
      getList();
    };
    //删除列表评论回复
    const deleteComments = (e) => {
      // 强制去掉按钮focus
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请先选择文章评论，可选中一个或多个");
        return;
      }
      var ids = [];
      data.multipleSelection.map((org) => {
        ids.push(org.id);
      });
      if (data.multipleSelection.length > 0) {
        ElMessageBox({
          title: "提示",
          message: h("p", null, [
            h("span", null, "确定将选中的【"),
            h(
              "b",
              { style: "color: #fd5252;font-size:16px" },
              `${data.multipleSelection.length}`
            ),
            h("span", null, "】条评论删除吗？ "),
          ]),
          showCancelButton: true,
          cancelButtonText: "取消",
          confirmButtonText: "确认",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              // 开启按钮加载
              instance.confirmButtonLoading = true
              instance.confirmButtonText = "确认中"
              // 删除接口
              Deletes(ids)
              .then((result) => {
                if (result && result.code == 1) {
                  done();
                  ElMessageBox.alert(result.message, "提示", {
                    confirmButtonText: "确认",
                  });
                  updateList();
                } else {
                  done();
                  ElMessageBox.alert(result.message, "提示", {
                    confirmButtonText: "确认",
                  });
                }
              })
              .catch((err) => {
                done();
                ElMessageBox.alert(err.message, "提示", {
                    confirmButtonText: "确认",
                  });
              })
            } else {
              done();
            }
          },
        })
          // .then(() => {
          //   var ids = [];
          //   data.multipleSelection.map((org) => {
          //     ids.push(org.id);
          //   });
          //   Deletes(ids).then((res) => {
          //     if (res.code === 1) {
          //       ElMessageBox.alert(res.message, "提示", {
          //         confirmButtonText: "确认",
          //       });
          //       updateList();
          //     } else {
          //       ElMessageBox.alert(res.message, "提示", {
          //         confirmButtonText: "确认",
          //       });
          //     }
          //   });
          // })
          .catch(() => {
            ElMessage("取消删除");
          });
      }
    };
    //打开评论内容弹窗
    const openContent = (val) => {
      if (val.prop == "content") {
        data.contentVisible = true;
        data.contentDetails = val.value.content;
      }
    };
    //打开评论回复列表弹窗
    const openReply = async (val) => {
      data.replyListVisible = true;
      if (
        data.contentReplyId === "" ||
        (val.id && data.contentReplyId != val.id)
      ) {
        data.contentReplyId = val.id;
      }

      const replyRes = await GetReplyList(data.contentReplyId);
      if (replyRes && replyRes.code == 1) {
        data.replyListData = replyRes.result;
      } else {
        ElMessageBox.alert(replyRes.message, "提示", {
          confirmButtonText: "确认",
        });
      }
    };
    //打开回复内容弹窗
    const openReplyContent = (val) => {
      data.contentReplyVisible = true;
      data.contentReplyDetails = val.replyContent;
    };
    // 删除回复内容
    const handleDelete = (val, e) => {
      // 强制去掉按钮focus
      lostFocus(e);
      ElMessageBox({
        title: "提示",
        message: "确认删除这条评论回复吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
      })
        .then(() => {
          var Replyid = val.commentsReplyId;
          DeleteReply(Replyid).then((res) => {
            if (res.code === 1) {
              ElMessageBox.alert(res.message, "提示", {
                confirmButtonText: "确认",
              });
              if(data.replyListData.length > 1){
                openReply(data.contentReplyId);
              }else{
                data.replyListData = [];
              }
              updateList(); //刷新列表
            } else {
              ElMessageBox.alert(res.message, "提示", {
                confirmButtonText: "确认",
              });
            }
          });
        })
        .catch(() => {
          ElMessage("取消删除");
        });
    };

    //编辑文章评论
    const editFnc = (obj) => {
      data.formComments.id = obj.id;
      data.formComments.createTime = obj.createTime;
      data.formComments.content = obj.content;
      // data.formComments.ip = obj.ip;
      data.editVisible = true;
    };

    // 编辑后提交校验
    const submitForm = async () => {
      await ruleFormRef.value.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          data.editDisabled = true;
          editsSubmit().then(() => {
            data.editDisabled = false;
          });;
        }
      });
    };
    //编辑文章评论提交
    const editsSubmit = async () => {
      const { code, message } = await EditComments(data.formComments);
      if (code === 1) {
        closeDialog(); //清空表单
        updateList(); //刷新列表
        ElMessageBox.alert(message, "提示", {
          confirmButtonText: "确认",
        });
        data.multipleSelection = [];
      } else {
        ElMessageBox.alert(message, "提示", {
          confirmButtonText: "确认",
        });
      }
    };
    //回复文章评论
    const replyArticleComments = (e) => {
      // 强制去掉按钮focus
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请选择一条文章评论回复");
        return;
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.error("只能选择一条文章回复");
        return;
      }
      data.replyComments.id = data.multipleSelection[0].id;
      data.replyComments.replyContent = "";
      data.formComments.createTime = data.multipleSelection[0].createTime;
      data.formComments.content = data.multipleSelection[0].content;
      data.replyVisible = true;
    };
    // 回复评论提交校验
    const submitReplyForm = async () => {
      await replyFormRef.value.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          replySubmit().then(() => {
            data.submitDisabled = false;
          });;
        }
      });
    };
    //回复评论提交
    const replySubmit = async () => {
      const { code, message } = await ReplyComments(data.replyComments);
      if (code === 1) {
        closeDialog(); //清空表单
        updateList(); //刷新列表
        ElMessageBox.alert(message, "提示", {
          confirmButtonText: "确认",
        });
        data.multipleSelection = [];
      } else {
        ElMessageBox.alert(message, "提示", {
          confirmButtonText: "确认",
        });
      }
    };
    // 批量审核评论
    const checkComments = (e) => {
      // 强制去掉按钮focus
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.error("请先选择文章评论，可选中一个或多个");
        return;
      }
      if (data.multipleSelection.length > 0) {
        var ids = [];
        data.multipleSelection.map((org) => {
          ids.push(org.id);
        });
        ElMessageBox({
          title: "提示",
          message: h("p", null, [
            h("span", null, "确定将选中的【"),
            h(
              "b",
              { style: "color: #fd5252;font-size:16px" },
              `${data.multipleSelection.length}`
            ),
            h("span", null, "】条评论通过审核？ "),
          ]),
          confirmButtonText: "确认",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              // 开启按钮加载
              instance.confirmButtonLoading = true;
              // 删除接口
              
              PassComments(ids)
              .then((result) => {
                if (result && result.code == 1) {
                  done();
                  resultHandle(result)
                  updateList();
                } else {
                  done();
                  resultHandle(result)
                
                }
              })
              .catch((err) => {
                done();
                resultHandle(err)
              })
            } else {
              done();
            }
          },
        })
          // .then(() => {
          //   var ids = [];
          //   data.multipleSelection.map((org) => {
          //     ids.push(org.id);
          //   });
          //   PassComments(ids).then((res) => {
          //     if (res.code === 1) {
          //       ElMessageBox.alert(res.message, "提示", {
          //         confirmButtonText: "确认",
          //       });
          //       updateList();
          //     } else {
          //       ElMessageBox.alert(res.message, "提示", {
          //         confirmButtonText: "确认",
          //       });
          //       updateList(); //刷新列表
          //     }
          //   });
          // })
          .catch(() => {
            ElMessage("取消审核");
          });
      }
    };
    // 取消操作重置编辑表单，关闭弹窗
    const resetForm = () => {
      closeDialog();
      ruleFormRef.value.resetFields();
    };
    // 取消操作重置回复表单，关闭弹窗
    const resetReplyForm = () => {
      closeDialog();
      replyFormRef.value.resetFields();
    };
    //关闭弹窗
    const closeDialog = () => {
      data.contentVisible = false;
      data.editVisible = false;
      data.replyVisible = false;
    };

    // 表格多选行处理
    const handleSelection = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };
    // 分页
    const changePagination = (val) => {
      data.search.pageIndex = val.currentPage;
      data.search.pageSize = val.pageSize;
      getList();
    };
    const resultHandle = (result) => {
           
      if(result?.result.length){
        let arr = []
        arr = result.result.filter(item=>item.code !== 1)
        if(arr.length){
          data.resultVisible = true
          data.resultList = arr
          data.resultTitle = '审核详情'
        }else{
          ElMessageBox.alert(result.message, "提示", {
            confirmButtonText: "确认",
          });
        }
        
      }else{
        ElMessageBox.alert(result.message, "提示", {
          confirmButtonText: "确认",
        });
      }
    }
    const ruleFormRef = ref();
    const replyFormRef = ref();

    return {
      ...toRefs(data),
      ruleFormRef,
      replyFormRef,
      getList,
      updateList,
      changePagination,
      searchFnc,
      editFnc,
      openContent,
      handleSelection,
      submitForm,
      resetForm,
      updateList,
      checkComments,
      replyArticleComments,
      submitReplyForm,
      replySubmit,
      resetReplyForm,
      openReply,
      openReplyContent,
      handleDelete,
      deleteComments,
      resultHandle,
    };
  },
};
</script>

<style>
.content-d .el-dialog__body {
  height: 300px;
  overflow: auto;
  margin-bottom: 20px;
  border-top: 1px solid #ebeef5;
}

.content-l .el-dialog__body {
  border-top: 1px solid #ebeef5;
}

.content-edit .el-dialog__body {
  height: 380px;
  overflow: auto;
}
.edit-form .el-form{
  height: 240px;
}
.content-edit .el-form-item .el-input {
  width: 400px;
  height: 40px;
}

.content-edit .el-form-item .el-textarea__inner {
  width: 400px;
}

#article-comments .el-table .cell.el-tooltip {
  line-height: 32px;
}
</style>